import script from "./WarehouseItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./WarehouseItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./WarehouseItemDetails.vue?vue&type=style&index=0&id=40f73b5e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f73b5e"]])

export default __exports__